import {useCallback} from 'react'
import {usePrefersReducedMotion} from '@github-ui/use-prefers-reduced-motion'
import {OVERVIEW_MERGE_BOX_ANCHOR_ID} from '../../../helpers/constants'
import {isMiniMergeboxEnabled} from './is-mini-mergebox-enabled'
import {DockedPanel, useDockedPanelActions} from '../../../contexts/DockedPanelContext'

export function useGoToMergeBox() {
  const scrollToMergeBox = useScrollToMergeBox()
  const openMergeBoxPanel = useOpenMergeBoxPanel()

  if (isMiniMergeboxEnabled()) {
    return openMergeBoxPanel
  } else {
    return scrollToMergeBox
  }
}

export function useScrollToMergeBox() {
  const prefersReducedMotion = usePrefersReducedMotion()

  return useCallback(() => {
    const mergeBox = document.getElementById(OVERVIEW_MERGE_BOX_ANCHOR_ID)
    if (!mergeBox) return

    mergeBox.scrollIntoView({behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start'})
    mergeBox.focus({preventScroll: true})
  }, [prefersReducedMotion])
}

export function useOpenMergeBoxPanel() {
  const {openPanel} = useDockedPanelActions()

  return useCallback(
    (returnFocusTo?: HTMLElement | null) => {
      openPanel(DockedPanel.MergeStatus, {returnFocusTo})
    },
    [openPanel],
  )
}
